import { useOptionalNotificationFeed } from 'features/notifications/lib/NotificationFeedContext';
import { useHasVisibleNotifications } from 'features/notifications/lib/useHasVisibleNotifications';
import { useAssistantEnabled } from 'features/onboarding/lib/useAssistantEnabled';

/**
 * Whether the control center has a Notifications tab.
 *
 * The panel is the feed's only home, so an account without the assistant has no in-app notifications
 * at all — not the tab, the launcher's bell, nor the pop-ups. Shared so none of those can disagree.
 * The feed check covers a user Knock hasn't issued a token to, whom the provider skips.
 */
export const useControlCenterNotifications = (): boolean => {
  const assistantEnabled = useAssistantEnabled();
  const hasVisibleNotifications = useHasVisibleNotifications();
  const feed = useOptionalNotificationFeed();

  return assistantEnabled && hasVisibleNotifications && feed !== null;
};
